import { useMemo } from 'react';
import type { MKEERAApiResponseItem } from '../dashboard.types';
import { parseAmount } from '../utils/dataProcessing';

export function useAverageAndHighestAssistance(data: MKEERAApiResponseItem[]) {
  return useMemo(() => {
    // Safety check: ensure data is an array
    if (!Array.isArray(data) || data.length === 0) {
      return { average: 0, highest: 0 };
    }

    const payments = data.map((item) => parseAmount(item.applicationData.amountOfPayment));
    const total = payments.reduce((sum, val) => sum + val, 0);
    const average = payments.length ? total / payments.length : 0;
    const highest = Math.max(...payments);
    return { average, highest };
  }, [data]);
}
